import React, { useState, useEffect } from "react";
import { Navbar, Button, Checkbox, Label } from "flowbite-react";
import List from "./list";
import DisplayRequiredDocument from "./displayRequiredDocuments";
import { VscChromeClose } from "react-icons/vsc";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../styles.css";
import {
  checkIfUserUpdatedAnyDoc,
} from "../../utils/updatedByUser";
import {
  handleDriverProfileSubmit,
  handleGetRequirementForMember,
} from "../handler";


const RequirementListForMember = () => {
  const navigate = useNavigate();
  // let [searchParams, setSearchParams] = useSearchParams();
  // const token = searchParams.get("token");
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  const transportType = sessionStorage.getItem("transportType")

  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [submit, setSubmitButton] = useState(true);
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [memberRequirement, setMemberRequirement] = useState();
  const [documentStatus, setDocumentStatus] = useState();
  const [selectedItemIndex, setSelectedItemIndex] = useState();
  const [openUploadDocument, setOpenUploadDocument] = useState({
    openDocument: false,
    documentType: "",
  });
  const [pageLoading, setPageLoading] = useState(true);

  const setSubmitButtonState = (type, value) => {
    if (type === "declaration" && value && privacyChecked) {
      setSubmitButton(false);
    } else if (type === "privacy" && value && declarationChecked) {
      setSubmitButton(false);
    } else {
      setSubmitButton(true);
    }
  };
  // 
  useEffect(() => {
    
    let redirectToDocument = sessionStorage.getItem('redirectToDocument')

    handleGetRequirementForMember(
      setMemberRequirement,
      setDocumentStatus,
      setPageLoading,
      setShowSaveButton,
      navigate,
      selectedProfileType.profileId,
      redirectToDocument,
      setSelectedItemIndex,
      setOpenUploadDocument
    );
  }, [openUploadDocument]);

  return (
    <>
      {!pageLoading && (
        <>
          {!openUploadDocument.openDocument && (
            <>
              <Navbar
                fluid={true}
                rounded={true}
                className="shadow mb-3"
                style={{ position: "fixed", width: "100%", top: "0" }}
              >
                <a
                  href={"rydedriver://open?action=home"}
                  onClick={() => {
                    window.location.href = "rydedriver://open?action=home";
                  }}
                >
                  <Navbar.Brand>
                    <div style={{ padding: "10px" }}>
                      <VscChromeClose />
                    </div>
                    <span className="self-center whitespace-nowrap text-md font-semibold dark:text-white">
                      Back to Home
                    </span>
                  </Navbar.Brand>
                </a>
                <div className="flex md:order-2"></div>
                {
                  transportType === "1" && 
                  <>
                    <Navbar.Brand>
                      <a onClick={()=>{
                        navigate('/?changeProfile=true')
                      }} 
                      className="self-center whitespace-nowrap text-md font-semibold dark:text-white right-btn">
                       Change Licence
                      </a>
                    </Navbar.Brand>
                  </>
                }
                

              </Navbar>

              {/* List all documents */}

              <List
                memberRequirement={memberRequirement}
                setMemberRequirement={setMemberRequirement}
                setOpenUploadDocument={setOpenUploadDocument}
                selectedItemIndex={selectedItemIndex}
                setSelectedItemIndex={setSelectedItemIndex}
                validation={validation}
                errorMessage={errorMessage}
                documentStatus={documentStatus}
                selectedProfile={selectedProfileType}
                setShowSaveButton={setShowSaveButton}
              />

              <div className="home-s shadow-md">
                <div className="m-auto mt-10 w-full max-w-md p-6" href="#">
                  {(![1, 2, 4].includes(documentStatus) ||
                    checkIfUserUpdatedAnyDoc()) &&
                    showSaveButton && (
                      <>
                        <h5 className="text-xl mb-5 font-bold tracking-tight text-gray-900 dark:text-white">
                          Review and Submit
                        </h5>

                        <div className="flex gap-2 mb-5">
                          <Checkbox
                            id="declaration"
                            onChange={(e) => {
                              setDeclarationChecked(e.target.checked);
                              setSubmitButtonState(
                                "declaration",
                                e.target.checked
                              );
                            }}
                          />
                          <Label
                            htmlFor="declaration"
                            className="text-gray-500"
                          >
                            I declare that the information provided is true and
                            correct. Any dishonesty may render for refusal of
                            this application or immediate termination of
                            partnership.
                          </Label>
                        </div>
                        <div className="flex gap-2">
                          <Checkbox
                            id="privacy"
                            onChange={(e) => {
                              setPrivacyChecked(e.target.checked);
                              setSubmitButtonState("privacy", e.target.checked);
                            }}
                          />
                          <Label htmlFor="privacy" className="text-gray-500">
                            By checking this, you have agree to our{" "}
                            <a
                              href="https://www.rydesharing.com/privacy-policy/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <u>Privacy Policy,</u>
                            </a>{" "}
                            Terms of Service, Code of Conduct, and Collecting
                            and Sharing Personal Data.
                          </Label>
                        </div>
                      </>
                    )}
                  {(![1, 2].includes(documentStatus) ||
                    checkIfUserUpdatedAnyDoc()) && (
                    <Button
                      className="w-full mt-5"
                      pill={true}
                      disabled={submit}
                      onClick={(e) => {
                        e.preventDefault();
                        handleDriverProfileSubmit(
                          memberRequirement,
                          setValidation,
                          setErrorMessage,
                          navigate,
                          selectedProfileType,
                          showSaveButton
                        );
                      }}
                    >
                      Submit For Review
                    </Button>
                  )}
                </div>
              </div>
            </>
          )}
          {openUploadDocument.openDocument && (
            <DisplayRequiredDocument
              memberRequirement={memberRequirement}
              openUploadDocument={openUploadDocument}
              setOpenUploadDocument={setOpenUploadDocument}
              setMemberRequirement={setMemberRequirement}
              selectedItemIndex={selectedItemIndex}
            />
          )}
        </>
      )}

      {pageLoading && (
        <div style={{ padding: "170px" }}>
          <svg
            width="60"
            height="20"
            viewBox="0 0 120 30"
            xmlns="http://www.w3.org/2000/svg"
            fill="#E93864"
          >
            <circle cx="15" cy="15" r="15">
              <animate
                attributeName="r"
                from="15"
                to="15"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="60" cy="15" r="9" fill-opacity="0.5">
              <animate
                attributeName="r"
                from="9"
                to="9"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
              />
            </circle>
            <circle cx="105" cy="15" r="15" fill-opacity="0.3">
              <animate
                attributeName="r"
                from="9"
                to="9"
                begin="0s"
                dur="0.8s"
                values="15;9;15"
                calcMode="linear"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
        </div>
      )}
    </>
  );
};

export default RequirementListForMember;
